import React, { useContext, useState } from 'react'
import Uploader from '../../common/Uploader'
import { deleteAttachment, uploadAttachment } from '../services/record-services'
import { AppContext } from '../Context'
import { Success } from '../../common/Text'
import { checkFilter, getAttachByCategory } from '../utils'


function RecordAttachmentUploader({ uploadConfig, attachConfig, filterSource, record, setRecord, showFiles = true, event, showLabel = true, ...props }) {
  const { tokenId } = useContext(AppContext)
  const [message, setMessage] = useState('')
  const onFileUpload = async (category, file) => {
    const result = await uploadAttachment(record._id, category, file, event)
    if (result && result.errors) {
      throw new Error(result.errors[0].message)
    }
    if (result && result.data.uploadAttachment) {
      setRecord({
        ...record,
        attachments: result.data.uploadAttachment.attachments
      })
    }
  }

  const onFileDelete = async (attachment) => {
    if (attachment) {
      const result = await deleteAttachment(record._id, [attachment.key])
      if (result && result.errors) {
        throw new Error(result.errors[0].message)
      }
      if (result && result.data.removeAttachment) {
        setRecord({
          ...record,
          attachments: result.data.removeAttachment.attachments
        })
      }
    }
  }

  const onFileClick = async (attachment) => {
    if (attachment) {
      window.open(`/beneficiary-api/rest/v1/record/${ record._id }/attachment/${ attachment.name }?key=${ attachment.key }&token=${ tokenId }`, '_blank')
    }
  }

  if (filterSource && attachConfig.filter && !checkFilter(filterSource, attachConfig)) {
    return null
  }

  return <Uploader
    key={ attachConfig.category }
    label={ showLabel ? attachConfig.label : '' }
    value={ showFiles && getAttachByCategory(record, attachConfig.category) }
    onFileUpload={ async (file) => {
      !showFiles && setMessage('')
      await onFileUpload(attachConfig.category, file)
      !showFiles && setMessage('Votre document a bien été téléchargé et transmis.')
    } }
    onFileDelete={ showFiles ? onFileDelete : null }
    onFileClick={ showFiles ? onFileClick : null }
    maxSize={ uploadConfig.maxSize }
    accept={ uploadConfig.accept }
    multiple={ true }
    { ...props }
  >
    { message && <Success>{ message }</Success> }
  </Uploader>
}

export default RecordAttachmentUploader
